const UserTabItemFill = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="25"
            viewBox="0 0 20 25"
            fill="none"
            {...props}
        >
            <path
                d="M13.4153 11.3463C13.6067 11.4268 13.7944 11.5151 13.9784 11.6102L13.9786 11.6103C15.059 12.1697 16.0206 12.9615 16.7338 13.9275C17.7352 15.2799 18.3235 17.0488 18.6196 18.4806C18.7686 19.2006 18.8474 19.8537 18.8647 20.3491C18.8733 20.5944 18.8675 20.8172 18.8422 20.9965C18.8297 21.0845 18.8099 21.1823 18.7747 21.2738C18.7476 21.344 18.6734 21.5151 18.4889 21.6151C18.4882 21.6155 18.4875 21.6158 18.4867 21.6162L18.2505 21.1756C11.1112 25.0921 1.38005 21.6425 1.30729 21.5473L13.4153 11.3463ZM13.4153 11.3463C13.4462 11.3278 13.4775 11.3086 13.509 11.2888C14.3383 10.7672 15.3342 9.81403 15.8558 8.06447L15.8561 8.06349C17.2281 3.42716 12.3038 -0.960322 7.59683 1.03735C5.31586 2.00027 3.71229 4.30322 3.77227 6.71464C3.79213 7.5618 3.99779 8.5357 4.56907 9.43119C4.94052 10.0135 5.45844 10.5496 6.15727 10.9914C4.27475 11.6291 3.04629 12.9428 2.17938 14.6654C1.42498 16.1633 1.06478 17.8646 0.900888 19.1883C0.818545 19.8534 0.784671 20.4322 0.776824 20.8553C0.772912 21.0663 0.77539 21.2427 0.782181 21.3743C0.785521 21.439 0.790257 21.5001 0.797106 21.5521C0.800412 21.5772 0.805424 21.6097 0.813535 21.6436C0.817562 21.6604 0.824237 21.6856 0.834925 21.7143C0.842974 21.7359 0.865897 21.7951 0.91475 21.857L13.4153 11.3463Z"
                fill="#686058"
                stroke="#686058"
            />
        </svg>
    )
}

export default UserTabItemFill
